module.exports = __webpack_public_path__ + "fonts/Typo_Round_Thin_Italic Demo.c4ddefdc.otf";